import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import BasicCard from './BasicCard';
import { ButtonTooltip } from '../Tooltips';
import Icon from '../../Icons';
import ability from '../../../config/ability';

const CardImage = ({
  item,
  image,
  rrhh,
  canEdit,
  showInfo,
  nameShow,
  showEdit,
  className,
  classNameNoImage,
  classNameDescription,
  nameKey,
  resend,
  location,
  onDelete
}) => {
  const imgSize = location === 'dashboard' ? 'img-size-dash' : 'img-size';
  const titleDash = location === 'dashboard' ? 'title-dash mb-0' : '';
  const heightCard = location === 'dashboard' ? '230px' : '550px';
  const isDashboard = location === 'dashboard';
  const descriptionHeightClass = !isDashboard ? 'description-height' : '';
  const descriptionHeightNoImageClass = !isDashboard && !image ? 'description-height-no-image' : '';
  const fullDescriptionClass = !isDashboard && !image ? 'full-description' : '';
  const dashboardExtraClass = isDashboard && !image ? 'dashboard-class' : '';
  const descriptionContent = (
    <div className={`flex-grow-1 ${descriptionHeightClass} ${dashboardExtraClass}`}>
      <div className="mb-0">
        <strong className="d-block text-decoration-underline">{item.title}</strong>
        <div
          className={`${classNameDescription} description-preview ${fullDescriptionClass}`}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(item.description)
          }}
        />
      </div>
    </div>
  );

  const content = (
    <div className="d-flex flex-column h-100 justify-content-between ass">
      <div className={`${classNameDescription} flex-grow-1 ${descriptionHeightNoImageClass} ${dashboardExtraClass}`}>
        <div className="mb-0">{descriptionContent}</div>
      </div>
    </div>
  );

  const buttons = (
    <div>
      <Row className="justify-content-end mt-auto">
        {rrhh && canEdit && ability.can('destroy', 'Benefit') && (
          <Col xs="auto" className="container-btn-edit btn-air">
            <Button variant="danger" onClick={() => onDelete?.(item.id)}>
              Eliminar
            </Button>
          </Col>
        )}

        {location !== 'dashboard' && rrhh && canEdit && (
          <Col xs="auto" className="btn-air">
            <ButtonTooltip
              block
              className="my-auto"
              variant="warning"
              text="Enviar Recordatorio"
              onClick={() => resend(item)}
            >
              <Icon width={18} icon="notifications" />
            </ButtonTooltip>
          </Col>
        )}

        {location !== 'dashboard' && (
          <Col xs="auto" className="btn-air">
            <Button
              block
              className={`${rrhh && canEdit ? 'my-auto' : 'mb-2'} ${location === 'dashboard' ? 'btn-sm' : ''}`}
              variant="primary"
              onClick={() => showInfo(item)}
            >
              {nameShow}
            </Button>
          </Col>
        )}

        {rrhh && canEdit && (
          <Col xs="auto" className="btn-air">
            <Button variant="outline-info" block onClick={() => showEdit(item)}>
              Editar
            </Button>
          </Col>
        )}
      </Row>
    </div>
  );

  return (
    <div className="card-image">
      <BasicCard
        classNameCard={`card-box ${className} ${!image && `bg-card-colors ${classNameNoImage}`}`}
        classNameImg={`${imgSize} ${rrhh && canEdit && 'img-size-edit'}`}
        classTitle={`${titleDash}`}
        src={image}
        title={item[nameKey]}
        size="100%"
        sizeHeight={heightCard}
        variantBtn="primary"
        divBody
        text={content}
        location={location}
        buttons={buttons}
      />
    </div>
  );
};

CardImage.propTypes = {
  item: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  image: PropTypes.string,
  rrhh: PropTypes.bool,
  canEdit: PropTypes.bool,
  showEdit: PropTypes.func,
  showInfo: PropTypes.func.isRequired,
  nameShow: PropTypes.string,
  className: PropTypes.string,
  classNameNoImage: PropTypes.string,
  classNameDescription: PropTypes.string,
  nameKey: PropTypes.string
};

CardImage.defaultProps = {
  item: null,
  nameKey: 'name',
  image: '',
  rrhh: false,
  canEdit: false,
  nameShow: 'Más info',
  className: '',
  classNameNoImage: '',
  classNameDescription: '',
  showEdit: () => null
};

export default CardImage;
